import React, { useEffect, useState } from "react";
import "./HomePage.scss";
import { useGetAllServiceDataQuery } from "../../../Services/vehicle/Vehicle";
import ReactModal, { Styles } from "react-modal";
import SubServiceModal from "./SubServiceModal";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { isAutoServicesTenant } from "../../../utils/tenantBranding";

interface IPROPS {
  vehicleData: any;
  setOpenVehicleModal: any;
  setIsCartOpen: any;
  setOpenModal: any;
  setCurrentStep: any;
  setVehicleData: any;
  setIsSubServiceModalOpen: any;
  isSubServiceModalOpen: any;
}

const AllServices: React.FC<IPROPS> = ({
  isSubServiceModalOpen,
  setIsSubServiceModalOpen,
  setOpenModal,
  setCurrentStep,
  setIsCartOpen,
  setOpenVehicleModal,
  vehicleData,
  setVehicleData,
}) => {
  const [services, setServices] = useState([]);
  const [activeServiceId, setActiveServiceId] = useState(null);
  const token = localStorage.getItem("customer-token");
  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiPort = process.env.REACT_APP_API_PROTOCOL;

  const navigate = useNavigate(); // Initializing useNavigate

  const fetchServices = async () => {
    try {
      const response = await axios.get(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/inventory/service-types/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setServices(response?.data);
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const customModalStyles: Styles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      padding: "0",
      marginTop: "80px",
      width: "90%",
      maxWidth: "800px",
      maxHeight: "90vh",
      overflowY: "auto",
      borderRadius: "10px",
    },
  };

  const closeModal = () => {
    setIsSubServiceModalOpen(false);
    setOpenModal("");
  };



  // Update: Retain token/modal/cart logic, then navigate if cart open
  const openBookingModal = () => {
    if (!token) {
      setOpenModal("login");
      return;
    } else if (token && vehicleData?.length === 0) {
      setOpenVehicleModal(true);
      return;
    } else {
      setCurrentStep(1);
      setIsCartOpen(true);
      navigate("/vehicle/select");
    }
  };

  const openServiceModal = (el) => {
    setIsSubServiceModalOpen(true);
    setActiveServiceId(el?.id);
  };


   
  const brandName = isAutoServicesTenant(fetchingTenant) ? "Autoservices" : "Eurorepar";

  return (
    <div className="all-services">
      <div className="services-left">
        <h2>OUR SERVICES</h2>
        <p>
          Take a look at the wide range of car and van services available at
          your local {brandName} Car Service centre. We deal with all makes and
          models of vehicles and offer a friendly, professional and expert
          service.
        </p>
        <p>
          Introducing our new flexible payment service plans that allow you to
          choose a payment option that suits you. View our Service Plan page to
          find out more!
        </p>
        <p>
          Whether you need a service, MOT, or repair, {brandName} is here to help.
        </p>

        <button className="book-btn" onClick={openBookingModal}>
          <span className="arrow">▶</span> BOOK ONLINE
        </button>
      </div>

      <div className="services-grid">
        {services?.map((service, index) => (
          <div
            className="service-box"
            key={index}
            onClick={() => openServiceModal(service)}
          >
            {service?.icon ? (
              <img src={service.icon} alt={service.title} />
            ) : (
              <span>
                <i
                  className="bi bi-tools"
                  style={{ fontSize: "20px", color: "white" }}
                ></i>
              </span>
            )}
            <p style={{ color: "black" }}>{service.name}</p>
          </div>
        ))}
      </div>

      <ReactModal
        isOpen={isSubServiceModalOpen}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel="Change Status"
      >
        <SubServiceModal
          setOpenModal={setOpenModal}
          setOpenVehicleModal={setOpenVehicleModal}
          vehicleData={vehicleData}
          token={token}
          setIsSubServiceModalOpen={setIsSubServiceModalOpen}
          setCurrentStep={setCurrentStep}
          setIsCartOpen={setIsCartOpen}
          activeServiceId={activeServiceId}
        />
      </ReactModal>
    </div>
  );
};

export default AllServices;
